module.exports = __webpack_public_path__ + "static/media/rounded.caa58e19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/rounded.svg
// module id = 1197
// module chunks = 68